import { AuthorizedUserModel } from '@framework/models/users/authorized-user.model';
import { ModelBase } from '@framework/models/base/base.model';

export class LoginOutputApiModel extends ModelBase {
    public userContext: AuthorizedUserModel    
    constructor(init?: Partial<LoginOutputApiModel>){
        super(init);
        Object.assign(this, init);
    }
}